module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Gimnasia RO.e09085de.png";